/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/trialEnd.scss';

import {Loader, voidFunction, WithBackground} from '@dvrd/dvr-controls';
import React, {MouseEventHandler} from 'react';
import {BolmateButton} from "../controls";
import FailedPayment from "../../models/failedPaymentModel";
import Image from "../misc/image";

interface Props {
    onProceed: MouseEventHandler;
    active: boolean;
    failedPayment: FailedPayment | null;
    loading: boolean;
    buttonDisabled: boolean;
}

export default function TrialEnd(props: Props) {
    const {active, onProceed, failedPayment, loading, buttonDisabled} = props;

    function renderMessage() {
        if (failedPayment) {
            const {paymentUrl, periodFromMoment, periodToMoment} = failedPayment;
            let subLabel = 'je abonnement';
            if (periodToMoment && periodFromMoment) {
                const dateFormat: string = periodFromMoment.isAt(periodToMoment, 'year') ? 'D MMMM' : 'D MMMM YYYY';
                subLabel = `de periode ${periodFromMoment.format(dateFormat)} t/m ${periodToMoment.format(
                    dateFormat)} van je abonnement`
            }
            if (paymentUrl) return (
                <p className='message-container'>
                    De automatische incasso voor {subLabel} is mislukt.<br/>
                    Geen probleem, kan gebeuren :)<br/><br/>
                    Er worden tijdelijk geen mails naar je klanten verzonden en geen facturen geüpload.<br/>
                    We hebben een nieuwe factuur gemaakt,<br/>
                    deze kun je via onderstaande knop inzien en betalen.<br/>
                    Na betaling kun je de pagina herladen en pakt het systeem het automatisch weer op!
                </p>
            );
            else return (
                <p className='message-container'>
                    De automatische incasso voor {subLabel} is mislukt.<br/>
                    Geen probleem, kan gebeuren :)<br/><br/>
                    Er worden tijdelijk geen mails naar je klanten verzonden en geen facturen geüpload.<br/>
                    Via onderstaande knop kan je een nieuwe factuur laten genereren.<br/>
                    Je wordt automatisch doorgestuurd naar de betaalpagina.<br/>
                    Na betaling kun je de pagina herladen en pakt het systeem het automatisch weer op!
                </p>
            );
        } else return (
            <p className='message-container'>
                Je abonnement is afgelopen.<br/>
                Er worden tijdelijk geen mails naar je klanten verzonden en geen facturen geüpload.<br/>
                Check je prijs, koppel een betaalmethode en hervat je gebruik.
            </p>
        );
    }

    function renderButton() {
        let label: string;
        if (failedPayment?.paymentUrl) label = 'Factuur inzien en betalen';
        else if (failedPayment) label = 'Abonnement hervatten';
        else label = 'Ga naar instellingen';
        return <BolmateButton onClick={onProceed} label={label} disabled={buttonDisabled}/>;
    }

    return (
        <WithBackground active={active} onClose={voidFunction} backgroundClass='trial-background'
                        backgroundColor='transparent' zIndex={1300} allowBodyScroll>
            <div className='trial-end'>
                <div className='header-container'>
                    <label className='header-title'>Abonnement is gepauzeerd</label>
                </div>
                <div className='body-container'>
                    <Loader active={loading}/>
                    <Image name='trial-rocket' className='trial-img'/>
                    {/*<img className='trial-img' src={getImg('trial-rocket')} alt='Bolmate.nl'/>*/}
                    <label className='body-title'>Doorgaan met Bolmate</label>
                    {renderMessage()}
                    {renderButton()}
                </div>
            </div>
        </WithBackground>
    )
}